const UserStatus = {
    Inactive : 0,
    Active : 1
}

export { UserStatus };